import { mapState, mapActions } from 'vuex'
import OrdersChart from '@/components/orders-chart/orders-chart.vue'
import Loader from '@/components/loader/loader.vue'
import IcRefresh from '@/assets/svg/ic-refresh.svg?inline'
import OrdersStatisticsModal from '@/components/modals/orders-statistics-modal/orders-statistics-modal.vue'

export default {
  name: 'OrderStatistics',
  props: {
    /**
     * контроль за первоначальной загрузкой из родительского компонента
     */
    notLoadMount: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrdersChart,
    Loader,
    IcRefresh,
    OrdersStatisticsModal
  },
  static() {
    return {
      tabsFields: ['accepted', 'in_delivery'],
      fieldsInOrder: ['today', 'week_ago', 'two_weeks_ago', 'week_ago_full_day']
    }
  },
  data() {
    return {
      selectedTab: this.tabsFields[0],
      isModalShow: false,
      dataStatistics: null,
      loading: false
    }
  },
  computed: {
    ...mapState({
      pageLoading: state => state.pageLoader.loading
    }),
    chartData() {
      return this.fieldsInOrder.reduce((acc, item) => {
        return [ ...acc, this.dataStatistics[this.selectedTab].total[item]  ]
      }, [])
    },
    showLoader() {
      return !this.pageLoading && !this.isModalShow && this.loading
    }
  },
  mounted() {
    if (!this.notLoadMount) {
      this.refreshExpressAnalysis()
    }
  },
  methods: {
    ...mapActions({
      cancelExpressAnalysis: 'regionOrders/cancelExpressAnalysis',
      getExpressAnalysys: 'regionOrders/getExpressAnalysys'
    }),
    /**
     * метод может вызываться из родительского компонента
     */
    async refreshExpressAnalysis() {
      try {
        this.loading = true
        await this.cancelExpressAnalysis()
        this.dataStatistics = await this.getExpressAnalysys()
      } finally {
        this.loading = false
      }
      
    },
    showDetail() {
      this.isModalShow = true
      this.$refs['orders-statistics-modal'].show()
    },
    onHideStatiscticModal() {
      this.isModalShow = false
    }
  }
}